import {Component, Input} from '@angular/core';
import {TWidgetKeys, WIDGET_COMPONENTS, WIDGET_TYPES, WidgetModel} from '../../model/widget.model';
import {TFormState} from '../../../../models/forms.model';
import {WidgetsService} from '../../services/widgets.service';
import {MatDialogRef} from '@angular/material/dialog';
import {AlertService} from '../../../../services/notify/alert.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-widget-create-new-settings.component',
    templateUrl: './widget-create-new-settings.component.html',
    styleUrl: './widget-create-new-settings.component.scss'
})
export class AppWidgetCreateNewSettingsComponent {
    @Input() widget: WidgetModel;
    public formState: TFormState
    public widgetsSet: string[] = []
    public selectedWidgetKey: TWidgetKeys = 'WIDGET_CRM_BOARD'
    public widgetsComponents = WIDGET_COMPONENTS;
    public widgetSettingsComponent: any

    constructor(
        private widgetService: WidgetsService,
        private alertService: AlertService,
        private translate: TranslateService,
        private dialogRef: MatDialogRef<AppWidgetCreateNewSettingsComponent>
    ) {
        this.widgetsSet = Object.keys(WIDGET_TYPES).filter(el=>el!=='WIDGET_EFT_CONTRACT_TABLE')
    }

    ngOnInit(): void {
        this.typeOfWidgetChanged('WIDGET_CRM_BOARD')
    }

    typeOfWidgetChanged(widgetKey: TWidgetKeys) {
        this.widget.widget_key = widgetKey
        this.widgetService.getWidgetSettings(this.widget).subscribe(widget => {
                this.widget = widget
                // this.widgetSettingsComponent = this.widgetsComponents.get(widget.widget_key + '_SETTINGS' as TWidgetKeys)?.component
            }
        )
    }

    updateSettings(action: 'Save' | 'Cancel') {
        action === 'Save' ? this.saveSettings() : this.cancelSave()
    }

    saveSettings() {
        this.formState = 'Submitting'
        let newWidget = {
            title: this.translate.instant('WIDGETS.WIDGETS_TITLES.' + this.widget.widget_key || ''),
            height: this.widget.height,
            width: this.widget.width,
            screen_x: this.widget.screen_x,
            screen_y: this.widget.screen_y,
            widget_key: this.widget.widget_key,
            widget_type: WIDGET_TYPES[this.widget.widget_key || 'WIDGET_CRM_BOARD'],
        }
        this.widgetService.createWidget(newWidget).subscribe({
            next: (data) => {
                this.widgetService.subWidgetNewHasCreated.next(data.widget)
                this.alertService.setAlert(data.message, 'green');
                this.formState = 'Default'
                this.dialogRef.close()

            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
                this.formState = 'Default'
            }
        });
    }

    cancelSave() {
        this.dialogRef.close()
    }
}